import { render, staticRenderFns } from "./AgentSettlements.vue?vue&type=template&id=31cd57f1&"
import script from "./AgentSettlements.vue?vue&type=script&lang=js&"
export * from "./AgentSettlements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports